import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { showSuccess, showError } from "../../utils/toast";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { RiCloseCircleFill } from "react-icons/ri";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import EditContractTemplatesForm from "./EditContractTemplatesForm";
import ButtonUI from "../material-ui/ButtonUI";
import { AuthContext } from "../../context/Auth/AuthContext";
import editContractTemplates from "../../api/editContractTemplates";
import { EditActionButton } from "../common/ActionIconButton";
import EditIcon from "@mui/icons-material/Edit";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <RiCloseCircleFill />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const editContractTemplatesFormSchema = yup.object().shape({
  contractName: yup.string().required("Contract Name is required field"),
  description: yup.string().required("Description is required field"),
  status: yup.string().required("Status is required field"),
  clientType: yup.string().required("Client Type is required field"),
  documentType: yup.string().required("Document Type is required field"),
  ocrStatus: yup.string().required("OCR Status is required field"),
});

const EditContractTemplatesPopup = ({ setContractTemplatesAddedToTrue, tableValues, typeOptions, docTypeOptions }) => {
  const [open, setOpen] = useState(false);
  const { token, user_id, is_admin } = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editContractTemplatesFormSchema),
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onEditContractTemplatesFormSubmit = async (editContractTemplatesFormData) => {
    const editContractFormResponse = await editContractTemplates({
      token: token,
      user_id: user_id,
      contract_request_setting_id: tableValues.contract_request_setting_id,
      contract_name: editContractTemplatesFormData.contractName,
      contract_description: editContractTemplatesFormData.description,
      status: editContractTemplatesFormData.status,
      client_type: editContractTemplatesFormData.clientType,
      document_type: editContractTemplatesFormData.documentType,
      ocr_status: editContractTemplatesFormData.ocrStatus,
      is_admin: is_admin,
    });

    if (editContractFormResponse.code === 200) {
      setContractTemplatesAddedToTrue();
      setOpen(false);

      showSuccess("Contract Template is updated successfully");
    } else {
      showError("Error while updating Contract Template");
    }
  };

  return (
    <div className="dialog-modal">
      <EditActionButton onClick={handleClickOpen} />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          className="edit-doc-modal"
          onClose={handleClose}
        >
          <div className="popup-header-svg-icon">
            <EditIcon />
          </div>
          <div className="popup-header-title">Edit Contract Template</div>
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <EditContractTemplatesForm
            register={register}
            control={control}
            errors={errors}
            tableValues={tableValues}
            typeOptions={typeOptions}
            docTypeOptions={docTypeOptions}
          />
        </DialogContent>
        <DialogActions>
          <div className="popup_submit_btn">
            <ButtonUI
              variant="contained"
              buttonText="Submit"
              handleSubmit={handleSubmit}
              onFormSubmit={onEditContractTemplatesFormSubmit}
            />
          </div>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default EditContractTemplatesPopup;
